import { AHText, Box } from "arkh";
import React, { PropsWithChildren } from "react";

export function InputSectionContainer(
  props: PropsWithChildren<{
    title: string;
    topRightElement?: React.ReactElement;
  }>
) {
  return (
    <Box color="surface" cornerRadius="medium" spaceVertical="small">
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHText
          type="title-small"
          spaceHorizontal="medium"
          color="washedText"
          style={{ flex: 1 }}
        >
          {props.title}
        </AHText>
        {props.topRightElement ? props.topRightElement : null}
      </Box>
      {props.children}
    </Box>
  );
}
